import { render, staticRenderFns } from "./add-change-role.vue?vue&type=template&id=2ca43c24&scoped=true"
import script from "./add-change-role.vue?vue&type=script&lang=js"
export * from "./add-change-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca43c24",
  null
  
)

export default component.exports